import { createApi } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL, createBaseQuery } from '../base/baseApi';

export const moderatorApi = createApi({
    tagTypes: ['Moderator'],
    reducerPath: 'moderatorApi',
    baseQuery: createBaseQuery({ baseUrl: `${API_BASE_URL}/moderator` }),
    endpoints: (builder) => ({
        fetchData: builder.query({
            query: () => ({
                url: '/fetch-data',
                method: 'GET',
            }),
            providesTags: ['Moderator'],
            transformResponse: (response) => response.Data,
        }),
        refreshData: builder.query({
            query: () => ({
                url: '/refresh-data',
                method: 'GET',
            }),
            providesTags: ['Moderator'],
            transformResponse: (response) => response.Data,
        }),
        deleteClient: builder.mutation({
            query: (clientId) => ({
                url: `/clients/${clientId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Moderator'],
        }),
        activateClient: builder.mutation({
            query: (clientId) => ({
                url: `/clients/${clientId}/activate`,
                method: 'PUT',
            }),
            invalidatesTags: ['Moderator'],
        }),
        deactivateClient: builder.mutation({
            query: (clientId) => ({
                url: `/clients/${clientId}/deactivate`,
                method: 'PUT',
            }),
            invalidatesTags: ['Moderator'],
        }),
    }),
});

export const {
    useFetchDataQuery,
    useLazyRefreshDataQuery,
    useDeleteClientMutation,
    useActivateClientMutation,
    useDeactivateClientMutation,
} = moderatorApi;